import './AboutUs.css'
import { Helmet } from 'react-helmet';

const AboutUs = () => {
    return(
        <div className="about-us-container">
            <Helmet>
                <meta name="description" content='Servo offers the most convenient way to book local professionals for home improvement services like Pest Control, Window Cleaning, and Home Cleaning, in St. George, UT. Enjoy a pristine, well-maintained home with our reliable experts.' />
                <title>Servo - Learn More About Us</title>
            </Helmet>
            <div className="about-us">
                <h1>About Us</h1>
            <section>
                <h2>Our Impact</h2>
                <p>Our mission is to minimize humanity's expenditure on quoting, scheduling, and billing tasks for home services.</p>
            <br/>
            <p> 
            Success for us not only means improving the service booking experience, it means overal lower costs for both local service providers and their customers.
            </p>
            </section>
            <section>
                <h2>Innovation at Our Core</h2>
                <p>While our mission begins with the application of existing technologies, Servo moves to the forefront of innovation in the home service industry with never before seen features. 
                    We are developing location-based scheduling paired with dynamic pricing, transforming the way services are scheduled and managed. 
                </p>
                <br/>
                <p>Servo's sights are set on expanding support to include carpet cleaning, auto detailing, mobile lube, yard maintenence, pool maintence, and much more. 
                    Our vision for the future is filled with possibilities, driven by innovation and community support.</p>
            </section>
            <section>
                <h2>Our History</h2>
                <p>In 2016, Servo's vision of simplifing the home service industry was born... it just didn't have a name yet. Starting with the idea of streamlining overlapping costs for service businesses like house cleaning and pest control, we've spent years refining our approach.</p>
                <br/>
                <p>Our journey took a significant leap forward between 2021 and 2022 when our prototype was developed on Shopify. 
                    As the need for more advanced technologies grew, all aspects of Servo were brought in-house and developed again from stratch, this time with advanced features in mind. 
                    Reconstruction of Servo started in late 2023 and is poised to launch again in 2024.</p>
            </section>
            <h2>Thank You!</h2>
            <p>Thank you for choosing Servo. Together, we're not just booking services; we're building a meaningful future. The purchases you make on Servo are the lifeblood of what moves this mission forward.</p>
            </div>
        </div>
    )
}

export default AboutUs;